/* Caviar product page: keeps the per-tin hints in step with Horizon's variant picker.
   Horizon fetches the section HTML for the chosen tin and fires `variant:update` with it;
   we copy our own [data-mc-caviar-live] fragments across from that HTML. */
(() => {
  if (window.mcCaviarPdp) return;
  window.mcCaviarPdp = true;

  // On narrow screens the compare row scrolls sideways: start it at the current caviar.
  const centreCurrent = () => {
    document.querySelectorAll('.mc-caviar-compare__row').forEach((row) => {
      const current = row.querySelector('.is-current');
      if (!current || row.scrollWidth <= row.clientWidth) return;
      row.scrollLeft = current.offsetLeft - (row.clientWidth - current.offsetWidth) / 2;
    });
  };
  // Wait for layout (section stylesheets load in the body), then centre once.
  if (document.readyState === 'complete') {
    centreCurrent();
  } else {
    window.addEventListener('load', centreCurrent, { once: true });
  }

  document.addEventListener('variant:update', (event) => {
    const html = event.detail && event.detail.data && event.detail.data.html;
    if (!html || typeof html.querySelectorAll !== 'function') return;
    const section = event.target instanceof Element ? event.target.closest('.shopify-section') : null;
    const scope = section || document;

    scope.querySelectorAll('[data-mc-caviar-live]').forEach((el) => {
      const key = el.getAttribute('data-mc-caviar-live');
      const next = html.querySelector(`[data-mc-caviar-live="${key}"]`);
      if (next) el.replaceWith(next.cloneNode(true));
    });
  });
})();
